(function () {
  const FROM = "•";
  const TO = " | "; // change to " | " or " / " or "" if you want none

  function fixSeparators() {
    document.querySelectorAll('.mu-item-variants').forEach(el => {
      if (el.textContent.includes(FROM)) {
        el.textContent = el.textContent.split(FROM).join(TO);
      }
    });
  }

  // Run once
  fixSeparators();

  // Re-run when Monster Cart updates (quantity changes, etc.)
  const observer = new MutationObserver(fixSeparators);
  observer.observe(document.body, { childList: true, subtree: true });
})();
